// Countries to exclude from profile options, either because duplicate or invalid
export const EXCLUDED_COUNTRIES = ['uk', 'eu', 'ap'];